import { render, staticRenderFns } from "./CallQueueCard.vue?vue&type=template&id=38dc1880&scoped=true"
import script from "./CallQueueCard.vue?vue&type=script&lang=ts"
export * from "./CallQueueCard.vue?vue&type=script&lang=ts"
import style0 from "./CallQueueCard.vue?vue&type=style&index=0&id=38dc1880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dc1880",
  null
  
)

export default component.exports